// Supabase client — singleton wired with project URL + publishable (anon) key.
// SECRET_KEY is server-only; daemon uses it. Browser uses publishable.
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. " +
    "Set them in .env.local for dev, or Cloudflare Pages env vars for prod.",
  );
}

export const supabase: SupabaseClient = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  realtime: {
    params: { eventsPerSecond: 5 },
  },
});

export type DBMessage = {
  id: number;
  session_id: string;
  user_id: string;
  role: "user" | "assistant" | "system" | "tool";
  content: string;
  tool_use: unknown | null;
  model: string | null;
  created_at: string;
};

export type DBSession = {
  id: string;
  user_id: string;
  title: string | null;
  created_at: string;
  last_active_at: string;
  archived: boolean;
};

export type DBBrief = {
  date: string;
  user_id: string | null;
  markdown: string;
  inbox_total: number | null;
  inbox_unread: number | null;
  m365_unread: number | null;
  rendered_at: string;
};
